/**
 * The meal schedule's shape and defaults, apart from the slice so the server
 * can read them (the weekly email plans against the same schedule as the app)
 * without bundling Redux Toolkit. `userPreferencesSlice` re-exports all of it.
 */

export type MealDietType = 'any' | 'meat' | 'vegetarian' | 'fish' | 'pasta';

export interface DayPreference {
  mealType: MealDietType;
  maxCookTimeMinutes: number | null; // null = no limit
  allowPrepAhead: boolean; // If true, slow cooker / prep-ahead meals bypass time constraint
  kidsPresent: boolean; // Future: could filter for kid-friendly
  defaultMealTime: string; // HH:MM format, default "18:00" — target dinner time for prep timeline
}

export interface WeeklyBalance {
  minVegetarianMeals: number; // 0-7
  minFishMeals: number; // 0-7
  maxRedMeatMeals: number; // 0-7
}

export interface MealFrequencyPreferences {
  vegetarianPerWeek?: number;
  fishPerWeek?: number;
}

export interface MealSchedulePreferences {
  days: Record<number, DayPreference>; // 0 = Sunday, 1 = Monday, ...6 = Saturday
  weeklyBalance: WeeklyBalance;
}

// Default day preference (no constraints)
export const DEFAULT_DAY_PREFERENCE: DayPreference = {
  mealType: 'any',
  maxCookTimeMinutes: null,
  allowPrepAhead: true,
  kidsPresent: false,
  defaultMealTime: '18:00',
};

// Default weekly balance
export const DEFAULT_WEEKLY_BALANCE: WeeklyBalance = {
  minVegetarianMeals: 1,
  minFishMeals: 1,
  maxRedMeatMeals: 4,
};

// Default schedule matching current hardcoded behavior
export const DEFAULT_MEAL_SCHEDULE: MealSchedulePreferences = {
  days: {
    0: { mealType: 'any', maxCookTimeMinutes: null, allowPrepAhead: true, kidsPresent: false, defaultMealTime: '18:00' }, // Sunday
    1: { mealType: 'any', maxCookTimeMinutes: 30, allowPrepAhead: true, kidsPresent: false, defaultMealTime: '18:00' }, // Monday
    2: { mealType: 'any', maxCookTimeMinutes: 30, allowPrepAhead: true, kidsPresent: false, defaultMealTime: '18:00' }, // Tuesday
    3: { mealType: 'vegetarian', maxCookTimeMinutes: 30, allowPrepAhead: true, kidsPresent: false, defaultMealTime: '18:00' }, // Wednesday
    4: { mealType: 'any', maxCookTimeMinutes: 30, allowPrepAhead: true, kidsPresent: false, defaultMealTime: '18:00' }, // Thursday
    5: { mealType: 'fish', maxCookTimeMinutes: null, allowPrepAhead: true, kidsPresent: false, defaultMealTime: '18:00' }, // Friday
    6: { mealType: 'any', maxCookTimeMinutes: null, allowPrepAhead: true, kidsPresent: false, defaultMealTime: '18:00' }, // Saturday
  },
  weeklyBalance: DEFAULT_WEEKLY_BALANCE,
};

